module.exports = {
	"title": "ご予約確認ページ",
	"privacyPolicy": "プライバシーポリシー",
	"term": "ご利用規約",
	"phoneNumberText": "ご予約時のお電話番号を入力すると、予約内容が確認できます。",
	"phoneNumber": "電話番号",
	"phoneNumberError": "電話番号に間違いがあるか、予約を確認できる期限が切れています。",
	"phoneNumberEnabledButton": "予約内容を確認する",
	"phoneNumberDisabledButton": "電話番号を入力してください",
	"reservationCanceled": "この予約はキャンセル済みです。",
	"reservationCancel": "この予約をキャンセルしました。",
	"course": "コース",
	"address": "住所",
	"phone": "店舗の連絡先",
	"contents": "ご予約内容",
	"date": "日時",
	"seats": "人数",
	"adults": "大人",
	"children": "お子様",
	"request": "ご要望とご質問",
	"reservationNumber": "ご予約番号",
	"noText": "ご予約のキャンセルまたは変更につきましては、恐れ入りますが当店まで直接お電話いただけますようお願いします。",
	"cancelButton": "キャンセルはこちら",
	"people": "名様",
	"confirm": "予約をキャンセルしますか？",
	"start": "開始",
	"deposit": "デポジット",
	"table_category": "席種",
	"private": "個室",
	"counter": "カウンター",
	"table": "テーブル",
	"none": "指定なし",
	"yes": "はい",
	"no": "いいえ",
	"doCancel": "ご予約をキャンセルします。よろしいですか？"
};


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/ja.json
// module id = 169
// module chunks = 0